import { render, staticRenderFns } from "./BDindex.vue?vue&type=template&id=0e319e0d&scoped=true"
import script from "./BDindex.vue?vue&type=script&lang=js"
export * from "./BDindex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e319e0d",
  null
  
)

export default component.exports